// --------------------------------------- Project List
import Facebook from "../Assets/Home_page.png";
import EaseMyTrip from "../Assets/FlightHome.png";
import Meal_Planner from "../Assets/Meal_Planner.png";
export const ProjectList = [
  {
    img: EaseMyTrip,
    title: "EaseMyTrip Clone",
    description: "Designed and developed a feature-rich Travel Booking platform, resembling EaseMyTrip, from the ground up. Implemented essential functionalities such as User Authentication, Login/Logout Processes, Search capabilities, Viewing Details, and a refined exploration experience. Users can now effortlessly explore and book flights, hotels, trains, and buses. ensuring a seamless experience across devices. Demonstrated strong problem-solving skills and attention to detail throughout the development process, resulting in a fully functional and user-friendly replica with expanded features.",
    tech_stack: "ReactJS, Javascript, HTML, CSS, Tailwind CSS, API",
    
    demo_url: "https://ease-my-trip-clone.vercel.app",
  },
  {
    img: Facebook,
    title: "Facebook Clone",
    description: "Designed and developed a feature-rich social media platform, resembling Facebook, from the ground up. Implemented essential functionalities such as user authentication, login/logout processes, adding posts, post liking, search capabilities, commenting on posts, and user profile viewing. Demonstrated strong problem-solving skills and attention to detail throughout the development process, resulting in a fully functional and user-friendly replica with expanded features.",
    tech_stack: "ReactJS, Javascript, HTML, CSS, API",
    
    demo_url: "https://reactproject-sd.vercel.app",
  },
  {
    img: Meal_Planner,
    title: "Meal Planner",
    description: "Designed and implemented a web application using JavaScript and HTML to generate personalized daily Calorie intake, Meal plans, and Recipes based on user input, including height, weight, age, and gender.",
    tech_stack: "HTML, CSS, Javascript, API",
    
    demo_url: "https://mealplannerweb.netlify.app",
  },
  
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/512px-HTML5_logo_and_wordmark.svg.png",
    name: "HTML",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1200px-CSS3_logo_and_wordmark.svg.png",
    name: "CSS",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Javascript-shield.svg/1200px-Javascript-shield.svg.png",
    name: "JavaScript",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
    name: "React",
  },
  {
    img: "https://www.svgrepo.com/show/342062/next-js.svg",
    name: "Next.Js",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/de/e/e1/Java-Logo.svg",
    name: "Java",
  },
  {
    img: "https://www.svgrepo.com/show/354430/tailwindcss.svg",
    name: "Tailwind CSS",
  },
  {
    img: "  https://www.svgrepo.com/show/221331/jsx.svg",
    name: "JSX",
  },
  {
    img: "https://www.svgrepo.com/show/303251/mysql-logo.svg",
    name: "MySQL",
  },
  {
    img: "https://www.svgrepo.com/show/530439/api-interface.svg",
    name: "API",
  },
  {
    img: "https://www.svgrepo.com/show/353782/git-icon.svg",
    name: "Git",
  },
  {
    img: "https://www.svgrepo.com/show/303210/figma-1-logo.svg",
    name: "Figma",
  },
  
  {
    img: "https://www.svgrepo.com/show/361509/github-logo.svg",
    name: "Github",
  },
  {
    img: "https://www.svgrepo.com/show/303269/microsoft-office-2013-logo.svg",
    name: "Microsoft-Office",
  },
  {
    img: "https://iconape.com/wp-content/png_logo_vector/c-programming-language-logo.png",
    name: "C",
  },
];
